module.exports = __webpack_public_path__ + "static/media/categories.db6bbb86.png";